module.exports = __webpack_public_path__ + "media/images/landing/we_believe_phone-ff1a709cea80b564256aa02ccba41e29.png";